module.exports = __webpack_public_path__ + "static/media/heat.bcf581c3.svg";